import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlementBalanceForwardReport extends Layout {
    sourceSettlementBalanceForward: DataSource;
    textboxPayeeType: Textbox;
    textboxPayees: Textbox;
}
